/* src/app/components/Sidebar/styles.js */

import { drawerWidth } from '../../../config/constants/styles';

export default theme => ({
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
  },
  item: {
    position: 'relative',
    // display: 'block',
    textDecoration: 'none',
  },
  active: {
    color: 'grey',
  },
  selects: {
    flexDirection: 'column',
    display: 'flex',
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    maxWidth: drawerWidth,
    marginTop: theme.spacing.unit,
  },
  formControl: {
    marginBottom: theme.spacing.unit,
    // maxWidtH: 150,
  },
  universitySelect: {
    zIndex: 1000000000,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/Sidebar/styles.js